module.exports = __webpack_public_path__ + "static/img/咨询投诉.454eb0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/咨询投诉.jpg
// module id = Rerb
// module chunks = 1